import React, { useEffect, useState,useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setFinalResultData } from '../store';
import axios from 'axios';

const Step3RunningAnalysis = ({ onComplete,setStep }) => {
    const algoFormData = useSelector((state) => state.analysisData.algoFormData);
    const stepOneformData = useSelector((state) => state.analysisData.stepOneformData);
    const dispatch = useDispatch();
    const hasFetched = useRef(false); // Track if API call was made
    const [progress, setProgress] = useState(0);
    const [orders, setOrders] = useState(0);
    const [products, setProducts] = useState(0);
    const [itemsets, setItemsets] = useState(0);
    const [elapsedSeconds, setElapsedSeconds] = useState(0);
    const [timerActive, setTimerActive] = useState(false);
    const [showError,setError] = useState("")

    const getFinalResult = async () => {
        let requestData = {
          ...algoFormData,
          ...stepOneformData
        };
      
        const url = 'https://upsell.webgarh.net/data-analysis';
        // const url = 'http://127.0.0.1:8000/data-analysis';

      
        try {
             // ⏱️ Start timer
            setElapsedSeconds(0);
            setTimerActive(true);

          const finalResult = await axios.post(url, requestData);
          dispatch(setFinalResultData(finalResult.data));
        //   console.log('Request:', requestData, 'Response:', finalResult.data);

        // ✅ Stop timer
    setTimerActive(false);

          const interval = setInterval(() => {
            setProgress((prev) => {
              const next = Math.min(prev + Math.random() * 10, 100);
              if (next === 100) {
                clearInterval(interval);
                setTimeout(onComplete, 100);
              }
              return next;
            });
  
            setOrders((o) => o + Math.floor(Math.random() * 20));
            setProducts((p) => p + Math.floor(Math.random() * 30));
            setItemsets((i) => i + Math.floor(Math.random() * 3));
          }, 100);
        } catch (error) {
          // ✅ Stop timer
          setTimerActive(false);
          setError(`${error.response?.data.detail || error.message}`)
          // console.error('CORS or request error:', error.response?.data || error.message);
        }
      };

      useEffect(() => {
        if (!hasFetched.current) { // Check if API call has already been made
          getFinalResult();
          hasFetched.current = true; // Set to true after the API call
        }
      }, [onComplete]);
      useEffect(() => {
        let timer;
        if (timerActive) {
          timer = setInterval(() => {
            setElapsedSeconds((prev) => prev + 1);
          }, 1000);
        }
      
        return () => clearInterval(timer);
      }, [timerActive]);

    return (
        <div className="bg-white rounded-xl shadow-md p-8 mb-8 text-center">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center justify-center">
                <i className="fas fa-cogs mr-3 text-indigo-500" /> Running Market Basket Analysis
            </h2>
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-500 mx-auto mb-6"></div>
            <p className="text-gray-600 mb-4">Processing your Shopify order data...</p>
            <p class="text-gray-600 mb-6">This may take a few minutes depending on your order volume ({Math.floor(elapsedSeconds / 60)}m {elapsedSeconds % 60}s)</p>
{
  showError &&
  <div class="flex flex-col items-center justify-center p-6 bg-red-50 border border-red-300 rounded-xl shadow-md max-w-md mx-auto mt-10">
  <div class="text-red-600 font-semibold text-lg mb-2">
    ⚠️ Something went wrong
  </div>
  <p class="text-sm text-red-500 mb-4">
  {showError}
  </p>
  <button
    onClick={() => { setStep(1) }}
    class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
  >
    🔁 Restart
  </button>
</div>
}
            <div class="w-full bg-gray-200 rounded-full h-2.5 mb-6">
                    <div id="analysis-progress" class="bg-indigo-600 h-2.5 rounded-full" style={{width:"100%"}}></div>
                </div>
            <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 max-w-2xl mx-auto">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <i class="fas fa-lightbulb text-yellow-500 mt-1"></i>
                        </div>
                        <div class="ml-3">
                            <h3 class="text-sm font-medium text-yellow-800">Analysis in progress</h3>
                            
                        </div>
                    </div>
                </div>
        </div>
    );
};

export default Step3RunningAnalysis;
